import { X } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';

export const SpaceDetails = (props) => {
    const { onClose, selectedValue, space } = props;

    const handleClose = () => {
      onClose(selectedValue);
    };

    return (
      <Dialog open={!!space} onOpenChange={(open) => !open && handleClose()}>
            {/*
             * A lightbox, so the content overrides the centred panel geometry:
             * it fills the viewport, drops the padding and lets the photo sit
             * on the dark ground rather than inside a card.
             */}
            <DialogContent
                showCloseButton={false}
                className="top-0 left-0 h-screen w-screen max-w-none translate-x-0 translate-y-0 place-items-center overflow-auto bg-background p-0 ring-0 sm:max-w-none"
            >
                {/* Radix needs a title for the dialog to be announced; the photo is the content. */}
                <DialogTitle className="sr-only">{space?.name || space?.spaceType}</DialogTitle>

                <Button
                    variant="outline"
                    size="icon"
                    aria-label="Close"
                    onClick={() => onClose()}
                    className="absolute end-6 top-5 z-10"
                >
                    <X />
                </Button>

                <img
                    src={space.uncroppedThumbnailPath}
                    alt={space?.name || space?.spaceType}
                    className="max-h-screen max-w-full object-contain"
                />
            </DialogContent>
      </Dialog>
    );
  }
